import React from "react";

export function getDisplayName<P>(Component: React.ComponentType<P>): string {
	return Component.displayName ?? (typeof Component === "function" ? Component.name : "");
}

export function wrappedDisplayName<P>(wrapperName: string, Component: React.ComponentType<P>): string {
	return wrapperName + "(" + getDisplayName(Component) + ")";
}
